
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  LegalEntitySearchResultResource,
  ValidationError,
} from '../models';
import {
    LegalEntitySearchResultResourceFromJSON,
    LegalEntitySearchResultResourceToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface ReindexAllLegalEntitiesRequest {
    forceAliasSwitch?: boolean;
}

export interface ReindexLegalEntitiesByOrganizationRequest {
    organizationId: string;
}

export interface ReindexLegalEntityRequest {
    legalEntityId: string;
}

export interface SearchLegalEntitiesRequest {
    searchText?: string;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class LegalEntityAdminSearchApi extends runtime.BaseAPI {

    /**
     * Reindex all legal entities (technical support endpoint)
          */
    async reindexAllLegalEntitiesRaw(requestParameters: ReindexAllLegalEntitiesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['forceAliasSwitch'] != null) {
            queryParameters['forceAliasSwitch'] = requestParameters['forceAliasSwitch'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-entities/reindex-all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Reindex all legal entities (technical support endpoint)
          */
    async reindexAllLegalEntities(requestParameters: ReindexAllLegalEntitiesRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.reindexAllLegalEntitiesRaw(requestParameters, initOverrides);
    }

    /**
     * Reindex all legal entities for an organization (technical support endpoint)
          */
    async reindexLegalEntitiesByOrganizationRaw(requestParameters: ReindexLegalEntitiesByOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling reindexLegalEntitiesByOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-entities/organization/{organizationId}/reindex`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Reindex all legal entities for an organization (technical support endpoint)
          */
    async reindexLegalEntitiesByOrganization(requestParameters: ReindexLegalEntitiesByOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.reindexLegalEntitiesByOrganizationRaw(requestParameters, initOverrides);
    }

    /**
     * Reindex a single legal entity (technical support endpoint)
          */
    async reindexLegalEntityRaw(requestParameters: ReindexLegalEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling reindexLegalEntity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-entities/{legalEntityId}/reindex`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Reindex a single legal entity (technical support endpoint)
          */
    async reindexLegalEntity(requestParameters: ReindexLegalEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.reindexLegalEntityRaw(requestParameters, initOverrides);
    }

    /**
     * Search for client legal entities (admin endpoint)
          */
    async searchLegalEntitiesRaw(requestParameters: SearchLegalEntitiesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalEntitySearchResultResource>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<LegalEntitySearchResultResource>({
            path: `/compliance/api/admin/legal-entities/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=LegalEntitySearchResultResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Search for client legal entities (admin endpoint)
          */
    async searchLegalEntities(requestParameters: SearchLegalEntitiesRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalEntitySearchResultResource> {
        const response = await this.searchLegalEntitiesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
